<div class="flex-1 justify-content-center align-items-center">
  <!--
  <div class="text-center">
    <img src="assets/iconos/logo.png" alt="Coverit">
  </div>

  <mat-divider></mat-divider>
  -->
  <div class="text-center">
    <router-outlet></router-outlet>
  </div>
</div>
